export enum XColumnType {
  STRING = 'string',
  DATE = 'date',
}
